import { generateReferralLink } from '@utils'
import { useTranslation } from 'react-i18next'

import { Text, useClipboard } from '@ds'
import { BottomSheet } from '@shared'
import { getUserObject } from '@store'

import styles from './InviteFriendPopup.module.scss'

type Props = {
  isOpen: boolean
  onClose: () => void
  inviteLink?: string
}

export const InviteFriendPopup = ({ isOpen, onClose, inviteLink }: Props) => {
  const { t } = useTranslation()
  const { copy } = useClipboard()

  const user = getUserObject()
  const defaultInviteLink = inviteLink || generateReferralLink(user.id)

  const handleCopy = () => {
    copy(defaultInviteLink, t('settings.invite.copied'))
  }

  return (
    <BottomSheet isOpen={isOpen} onClose={onClose}>
      <div className={styles.content}>
        <div className={styles.header}>
          <Text type="h1" center className={styles.title}>
            {t('settings.invite.title')}
          </Text>
          <Text type="body" center className={styles.subtitle}>
            {t('settings.invite.subtitle')}
          </Text>
        </div>

        <div className={styles.actions}>
          <div className={styles.linkContainer}>
            <div className={styles.linkInput}>
              <Text type="body" className={styles.linkText}>
                {defaultInviteLink}
              </Text>
            </div>
            <button
              className={styles.copyButton}
              onClick={handleCopy}
              type="button"
            >
              <Text type="body" center>
                {t('settings.invite.copy')}
              </Text>
            </button>
          </div>
        </div>
      </div>
    </BottomSheet>
  )
}
